import { useContext } from 'react';
import { Card, Descriptions } from 'antd';
import { Bar } from 'react-chartjs-2';
import { PageContext } from '../../../lib/context';
import { useBarcode } from 'react-barcodes';
import moment from 'moment';

const CustomerReceit = () => {
  const {
    graphData,
    settingsInfo,
    info,
    subs_id,
    actualPayments,
    addFeesTable,
  } = useContext(PageContext);
  const { inputRef } = useBarcode({
    value: subs_id(info?.id),
    options: {
      displayValue: false,
      background: '#ffffff',
      width: 1.5,
      height: 40,
    },
  });
  return (
    <div>
      <div className="box-border border-2 border-indigo-500 flex flex-col text-sm">
        <div className="flex justify-center bg-indigo-500 text-gray-50 py-2 font-bold">
          CONSUMER INFORMATION
        </div>
        <div className="flex flex-row">
          <div className="mr-8 ml-8 mt-3 w-2/4">
            <Descriptions>
              <Descriptions.Item>{`${info?.subscriber?.last_name}, ${info?.subscriber?.first_name}`}</Descriptions.Item>
            </Descriptions>
            <Descriptions.Item>
              {info?.subscriber?.complete_address}
            </Descriptions.Item>
          </div>
          <div className="mr-8 ml-8 mt-3">
            <div className="mb-1">
              Account Code: {subs_id(info?.id ? info.id : info?.subscriber?.id)}
            </div>
            <div className="mb-1">
              Consumer Type: {`${info?.subscriber.rate.name}`}
            </div>
            <div className="mb-1">
              Zip Code: {`${info?.subscriber?.zip_code}`}
            </div>
            <div className="mb-3">
              Billing Statement: {info?.billing_id && subs_id(info?.billing_id)}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row mt-1">
        <div className="mr-1 w-2/4 box-border border-2 border-indigo-500">
          <div className="flex justify-center bg-indigo-500 text-gray-50 py-2 font-bold">
            METER INFORMATION
          </div>
          <div className="flex flex-row">
            <div className="mr-8 ml-8 mt-3 w-2/6">
              {/* <div className="mb-2">
                Brand:{' '}
                {info?.subscriber?.meter?.brand
                  ? `${info?.subscriber?.meter?.brand}`
                  : '---'}
              </div>
              <div className="mb-2">
                Model:{' '}
                {info?.subscriber?.meter?.model
                  ? `${info?.subscriber?.meter?.model}`
                  : '---'}
              </div> */}
              <div className="mb-3">
                Meter ID:{' '}
                {info?.subscriber?.meter?.serial_number &&
                  `${info?.subscriber?.meter?.serial_number}`}
              </div>
            </div>
            <div className="mr-8 ml-8 mt-3">
              <div className="mb-1">
                Due Date:{' '}
                {settingsInfo?.[0]?.deadline &&
                  moment()
                    .startOf('month')
                    .add(settingsInfo?.[0]?.deadline, 'days')
                    .format('LL')}
              </div>
              <div className="mb-1">
                Period From:{' '}
                {info?.previous_reading_date
                  ? moment(info?.previous_reading_date).format('LL')
                  : '---'}
              </div>
              <div className="mb-1">
                Period To:{' '}
                {info?.current_reading_date
                  ? moment(info?.current_reading_date).format('LL')
                  : '---'}
              </div>
            </div>
          </div>
          <div className="flex flex-row-3 text-center mt-8">
            <div className="mr-8 ml-8 mt-3 w-2/6">
              <div className="mb-2">
                Date:
                <br />
                {info?.current_reading_date
                  ? moment(`${info?.current_reading_date}`).format('LL')
                  : '---'}
                <br />
              </div>
            </div>
            <div className="mr-8 ml-8 mt-3">
              <div className="mb-1">
                Reading:
                <br />
                {info?.current_reading
                  ? `${Math.round(info?.current_reading * 100) / 100}`
                  : '---'}
                <br />
              </div>
            </div>
            <div className="mr-8 ml-8 mt-3">
              <div className="mb-1">
                Consumption:
                <br />
                {info?.consumption
                  ? `${Math.round(info?.consumption * 100) / 100}`
                  : '---'}
              </div>
            </div>
          </div>
          <Card
            style={{
              borderRadius: 10,
              height: 300,
              width: 300,
              marginLeft: 80,
              marginBottom: 20,
              marginTop: 10,
            }}
          >
            <Bar height={100} width={100} data={graphData} type="line" />
          </Card>
        </div>
        <div className="box-border border-2 border-indigo-500 w-2/4">
          <div className="flex justify-center bg-indigo-500 text-gray-50 py-2 font-bold">
            BILLING DETAILS
          </div>
          <div className="p-4">
            <div className="grid grid-cols-3">
              <div className="mb-1">
                <h3>Charges</h3>
              </div>
              <div className="mb-1">
                <h3>Period</h3>
              </div>
              <div className="mb-1 text-right">
                <h3>Amount</h3>
              </div>
              <div className="text-sm  mb-1">Water Fee</div>
              <div className="text-sm  mb-1">
                {info?.billing_date && moment(info?.billing_date).format('LL')}
              </div>
              <div className="text-sm  mb-1 text-right">
                {info?.water_fee
                  ? `${Math.round(info?.water_fee * 100) / 100}`
                  : 0}
              </div>
            </div>
          </div>
          {info?.additional_bills?.length > 0 && (
            <div className="p-4">
              <h3>Additional Fees</h3>
              {info.additional_bills.map((bill: any, index: number) => {
                return (
                  <div className="mb-1 grid grid-cols-3" key={`${index}`}>
                    <div className="text-sm">
                      {`${bill.additional_fee_information?.title} (${addFeesTable?.[0]?.paid?.aggregate?.count}/${addFeesTable?.[0]?.count?.aggregate?.count})`}
                    </div>
                    <div className="text-sm">
                      {info?.billing_date &&
                        moment(info?.billing_date).format('LL')}
                    </div>
                    <div className="text-sm text-right">
                      {bill.amount.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <div className="p-4">
            <div className="grid grid-cols-2">
              {/** gross current bill */}
              <div className="mb-1 text-sm">Gross Current Bill</div>
              <div className="text-sm text-right mb-1">
                {info?.gross_current_bill
                  ? `${Math.round(info?.gross_current_bill * 100) / 100}`
                  : 0}
              </div>
              {/** previous balance */}
              <div className="mb-1 text-sm">Previous Balance</div>
              <div className="text-sm text-right mb-1">
                {info?.previous_balance
                  ? `${Math.round(info?.previous_balance * 100) / 100}`
                  : 0}
              </div>
              {/** advance payment */}
              <div className="mb-1 text-sm">Advance Payment</div>
              <div className="text-sm text-right mb-1">
                {info?.advance_payment
                  ? `${Math.round(info?.advance_payment * 100) / 100}`
                  : 0}
              </div>
              {/** discount on advance payment */}
              <div className="mb-1 text-sm">Discount on Advance</div>
              <div className="text-sm text-right mb-1">
                {info?.gross_current_bill
                  ? `${Math.round(info?.gross_current_bill * 100) / 100}`
                  : 0}
              </div>
              {/** current payment */}
              <div className="mb-1 text-sm">Current Payment</div>
              <div className="text-sm text-right mb-1">
                {info?.payments ? Math.round(info.payments * 100) / 100 : 0}
              </div>
              <div className="mb-1 text-sm">Remaining Balance</div>
              <div className="text-sm text-right mb-1">
                {(info?.total_balance
                  ? Math.round(info?.total_balance * 100) / 100
                  : 0) -
                  (info?.payments ? Math.round(info.payments * 100) / 100 : 0)}
              </div>
            </div>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-2">
              <div className="text-sm mb-1">Total Amount Due</div>
              <div className="text-sm mb-1 text-right">
                {info?.total_balance
                  ? `${Math.round(info?.total_balance * 100) / 100}`
                  : 0}
              </div>
              <div className="text-sm mb-1">Current Bill Period</div>
              <div className="text-sm mb-1 text-right">
                {info?.current_reading_date &&
                  moment(info?.current_reading_date).format('LL')}
              </div>
            </div>
          </div>

          <div className="text-xs mr-8 ml-6 mb-3 mt-32">
            <div>
              *Please pay on or before due date{' '}
              {settingsInfo?.[0]?.deadline &&
                moment()
                  .startOf('month')
                  .add(settingsInfo?.[0]?.deadline, 'days')
                  .format('LL')}
            </div>
          </div>
        </div>
      </div>

      <div className="box-border border-2 border-indigo-500 flex flex-col text-sm mt-1">
        <div className="box-border border-b-2 border-indigo-500 w-500 mt-12"></div>
        <div className="flex flex-col">
          <div className="mr-8 ml-8 mt-3">
            <div className="mb-2">
              <p className="text-justify text-xs">
                BE MINDFUL OF YOUR WATER BILLS. DON'T WAIT FOR YOUR MONTHLY
                WATER BILL JUST TO KNOW LEAKS IN YOUR PIPELINES. MONITOR
                FREQUENTLY YOUR METER READING. IF CONSUMPTION SUDDENLY SHOOTS UP
                COMPARED TO YOUR USUAL DAILY CONSUMPTION, YOUR WATER LINES COULD
                HAVE LEAKS. CONTINUOUS TURNING OF WATER METER DEAL EVEN IF ALL
                YOUR FAUCETS/ VALVES ARE CLOSED IS ALSO AN INDICATION OF LEAK.
                WATER LOST DUE TO LEAKS ARE DEEMED CONSUMED BY THE CONSUMER.
              </p>
            </div>
            <div className="flex flex-row-reverse mb-5 mt-16">
              <div className="grid grid-cols-2">
                <div className="border-t-2 text-center border-indigo-500">
                  Bill Distributor
                </div>
                <div className="ml-12 mr-8">
                  <div className="border-t-2 text-center border-indigo-500 w-32">
                    Date
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="box-border border-2 border-indigo-500 flex flex-col text-sm mt-1">
        <div className="flex justify-center bg-indigo-500 text-gray-50 py-2 font-bold">
          PAYMENT STUB
        </div>
        <div className="flex flex-col">
          <div className="mr-8 ml-8 mt-3">
            <div className="flex flex-row">
              <div className="mr-32 mt-3 mb-1 w-2/4">
                <div>{`${info?.subscriber.last_name}, ${info?.subscriber.first_name}`}</div>
                <div>{`${info?.subscriber.complete_address}`}</div>
              </div>
              <div className="ml-40">
                <svg ref={inputRef} />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="mr-8 ml-8 mb-3 text-xs flex flex-cols-2">
            <div className="flex flex-col-2 grid grid-cols-2 divide-x w-max">
              <div>
                <div>Zip Code</div>
                <div>Current Bill</div>
                <div>Previous Bill</div>
                <div>Total Amount Due</div>
                <div>Advance Payment</div>
              </div>
              <div className="ml-9 text-right">
                <div>{`${info?.subscriber?.zip_code}`}</div>
                <div>
                  {info?.gross_current_bill ? `${info?.gross_current_bill}` : 0}
                </div>
                <div>
                  {info?.previous_balance ? `${info?.previous_balance}` : 0}
                </div>
                <div>
                  {info?.total_balance
                    ? `${Math.round(info?.total_balance * 100) / 100}`
                    : 0}
                </div>
                <div>
                  {info?.advance_payment
                    ? `${Math.round(info?.advance_payment * 100) / 100}`
                    : 0}
                </div>
              </div>
            </div>
            <div className="flex flex-col-2 grid grid-cols-2 divide-x">
              <div className="ml-14">
                <div>Account Code</div>
                <div>Due Date</div>
                <div>Billing Statement</div>
              </div>
              <div className="ml-9 text-right">
                <div>{subs_id(info.id)}</div>
                <div>
                  {settingsInfo?.[0]?.deadline &&
                    moment()
                      .startOf('month')
                      .add(settingsInfo?.[0]?.deadline, 'days')
                      .format('LL')}
                </div>
                <div>{info?.id && subs_id(info.billing_id)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="box-border border-t-2 border-indigo-500 w-500">
                <div className="mr-8 ml-8 mt-3 mb-3">
                    <p className="text-indigo-700 font-normal italic text-justify" >
                        Please make checks payable to <a className="underline font-semibold">Metropolitan Cebu Water  District</a> .
                        Indicate your Name, Consumer Code, Telephone Numbers and
                        Signature at the back of the check.
                    </p>
                </div>
            </div> */}
    </div>
  );
};

export default CustomerReceit;
